/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './FundsList.scss';

import { array, bool, func, object } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import Checkbox from 'components/shared/Checkbox/Checkbox';
import { isMobileLayout } from 'state/view/ViewSelectors';

const Fund = ({ checked, fund, onChange }) => (
  <div className="fund">
    <Checkbox
      checked={checked}
      className="fund-checkbox"
      label={fund.name}
      name={`${fund.name}-checkbox`}
      onChange={onChange}
    />
  </div>
);

Fund.propTypes = {
  checked: bool.isRequired,
  fund: object.isRequired,
  onChange: func.isRequired
};

const FundsList = ({ assetClassChecked, funds, isMobileLayout, onCheck }) => {
  const handleFundSelect = (assetClassName) => (checked) => {
    onCheck(assetClassName, checked);
  };

  if (isMobileLayout) {
    return (
      <div className="funds-list">
        <div className="fund-column">
          {funds.map((fund, idx) => (
            <Fund
              checked={Boolean(assetClassChecked[fund.name])}
              fund={fund}
              key={idx}
              onChange={handleFundSelect(fund.name)}
            />
          ))}
        </div>
      </div>
    );
  }

  const numberOfFunds = funds.length;
  const middleIdx = Math.floor(numberOfFunds / 2);
  const firstColumnFunds = funds.slice(0, middleIdx);
  const secondColumnFunds = funds.slice(middleIdx);

  return (
    <div className="funds-list">
      <div className="fund-column">
        {firstColumnFunds.map((fund, idx) => (
          <Fund
            checked={Boolean(assetClassChecked[fund.name])}
            fund={fund}
            key={idx}
            onChange={handleFundSelect(fund.name)}
          />
        ))}
      </div>
      <div className="fund-column">
        {secondColumnFunds.map((fund, idx) => (
          <Fund
            checked={Boolean(assetClassChecked[fund.name])}
            fund={fund}
            key={idx}
            onChange={handleFundSelect(fund.name)}
          />
        ))}
      </div>
    </div>
  );
};

FundsList.propTypes = {
  assetClassChecked: object.isRequired,
  funds: array.isRequired,
  isMobileLayout: bool.isRequired,
  onCheck: func.isRequired
};

const mapStateToProps = (state) => ({
  isMobileLayout: isMobileLayout(state)
});

export default connect(mapStateToProps)(FundsList);
